import { z } from "zod/v3";
import { OccupationsForTrack as ProtoOccupationsForTrack } from "@opstel/gen/knop/ui/v1/model/occupations_for_track_pb";
import { ZodOutputFor, createSchema } from "../zod-utils";
import { PlainMessage } from "@bufbuild/protobuf";
import { Track, TrackWithBlockedDurations, trackSchema } from "./track";
import { TrackOccupation, trackOccupationSchema } from "./trackOccupation";
import { WithBlockedInfrastructures } from "./types/context";

export interface OccupationsForTrack extends ParsedOccupationsForTrack {
  track: TrackWithBlockedDurations;
}
export interface ParsedOccupationsForTrack {
  track: Track;
  occupations: TrackOccupation[];
}
export const occupationsForTrackSchema = createSchema<
  ParsedOccupationsForTrack,
  PlainMessage<ProtoOccupationsForTrack>
>({
  track: trackSchema,
  occupations: z.array(trackOccupationSchema),
}) satisfies ZodOutputFor<ParsedOccupationsForTrack>;

type OccupationsForTrackContext = WithBlockedInfrastructures;
export const OccupationsForTrack = {
  postProcess: (
    occupationsForTrack: ParsedOccupationsForTrack,
    ctx: OccupationsForTrackContext,
  ): OccupationsForTrack => ({
    track: Track.postProcessWithBlockedDurations(occupationsForTrack.track, ctx),
    occupations: occupationsForTrack.occupations,
  }),
};
